<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :onFormSubmit="handleSubmit"
    title="游客"
    resource="visitor_accounts"
  >
    <template slot="action">
      <bean-import-button
        can='accounts.create'
        buttonText="导入个人客户"
        tooltipText="下载导入模板"
        url="/personal_accounts/import"
        loadingToast="导入中...请不要刷新页面"
        excelTemplateDownloadLink="/admin_api/v1/personal_accounts/import_template"
      />
      <bean-import-button
        can='accounts.create'
        buttonText="导入企业客户"
        tooltipText="下载导入模板"
        url="/company_accounts/import"
        loadingToast="导入中...请不要刷新页面"
        excelTemplateDownloadLink="/admin_api/v1/company_accounts/import_template"
      />
      <bean-import-button
        can='accounts.create'
        buttonText="导入产品客户"
        tooltipText="下载导入模板"
        url="/product_accounts/import"
        loadingToast="导入中...请不要刷新页面"
        excelTemplateDownloadLink="/admin_api/v1/product_accounts/import_template"
      />
      <bean-import-button
        can='accounts.create'
        buttonText="导入代理人客户"
        tooltipText="下载导入模板"
        url="/agent_accounts/import"
        loadingToast="导入中...请不要刷新页面"
        excelTemplateDownloadLink="/admin_api/v1/agent_accounts/import_template"
      />
    </template>
  </bean-source-page>

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend } from '@/admin_grapes/visitor_accounts.js';
import { formColumnsExtend } from '@/admin_grapes/accounts.js';
import _ from 'lodash';
import { abilityService } from 'beans-admin-plugin';
import { linkTo } from '@/custom_columns_extend';

@Component
export default class VisitorAccounts extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  get agentTargetIdRenderCell() {
    return {
      props: {
        xRemotePreload: async () => {
          const { data } = await this.$request.get('/accounts/read_options', { per_page: 100, type_in: ['PersonalAccount', 'ProductAccount', 'CompanyAccount'] });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const { data } = await this.$request.get('/accounts/read_options', { keyword, type_in: ['PersonalAccount', 'ProductAccount', 'CompanyAccount'] });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'type',
      'name',
      'number',
      'user',
      {
        key: 'risk_assessment_level',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <bean-link keepNode to={{ name: 'risk_assessment_results.index', query: { account_id_eq: row.id } }} can={'risk_assessment_results.read'}>{this.$t(`account.riskAssessmentLevels.${value}`)}</bean-link>
        }
      },
      {
        key: 'has_video_records',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'video_records.index', query: { account_id_eq: row.id } }} can={'video_records.read'}>是</bean-link>
          }
          return <bean-link keepNode to={{ name: 'video_records.new' }} can={'video_records.create'}>否</bean-link>
        }
      },
      'is_staff',
      'kind',
      {
        key: 'agent_target',
        filterColumns: [{
          label: '等于',
          renderCell: this.agentTargetIdRenderCell
        }]
      },
      'referrer',
      { key: 'certificate_end_date', minWidth: 120 },
      'phone',
      'email',
      'address',
      'city',
      'status',
      'reject_reason',
      'login_activities_count',
      type === 'show' && 'personas',
      type === 'show' && abilityService.can('accounts.update_remark') && 'remark',
      type === 'show' && 'audio_or_video_recording_file',
      type === 'show' && 'bank_card_scan_file',
      type === 'show' && 'fund_contract',
      type === 'show' && 'number_scan_file',
      type === 'show' && 'proof_of_assets',
      type === 'show' && 'qualified_investor_commitment_letter',
      type === 'show' && 'risk_assessment_file',
      type === 'show' && 'risk_disclosure',
      type === 'show' && 'supplementary_agreement_to_fund_contract',
      type === 'show' && 'other_files',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const fileDefaultRenderCell = {
      renderCell: {
        props: {
          accept: 'application/pdf, application/zip',
          type: 'application',
          size: 20
        }
      }
    }

    const array = [
      'type',
      data.type === 'PersonalAccount' && 'is_staff',
      data.type === 'ProductAccount' && {
        key: 'kind',
        renderCell: {
          required: true
        }
      },
      data.type === 'AgentAccount' && {
        key: 'agent_target_id',
        renderCell: _.merge(this.agentTargetIdRenderCell, { required: true })
      },
      'referrer',
      'number',
      (data.type === 'PersonalAccount' || data.type === 'AgentAccount') && 'user_id',
      'certificate_end_date',
      'risk_assessment_level',
      'name',
      'phone',
      'email',
      'address',
      'city',
      _.merge({}, fileDefaultRenderCell, { key: 'audio_or_video_recording_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'bank_card_scan_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'fund_contract' }),
      _.merge({}, fileDefaultRenderCell, { key: 'number_scan_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'proof_of_assets' }),
      _.merge({}, fileDefaultRenderCell, { key: 'qualified_investor_commitment_letter' }),
      _.merge({}, fileDefaultRenderCell, { key: 'risk_assessment_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'risk_disclosure' }),
      _.merge({}, fileDefaultRenderCell, { key: 'supplementary_agreement_to_fund_contract' }),
      _.merge({}, fileDefaultRenderCell, {
        key: 'other_files',
        renderCell: {
          props: {
            limit: 5,
          }
        }
      }),
      'personas',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'visitor_accounts.edit', params: { id: row.id } },
          can: 'accounts.update'
        }
      },
      _.includes(['pending', 'rejected'], row.status) && {
        component: 'confirmButton',
        props: {
          label: '同意',
          type: 'primary',
          can: 'accounts.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/approve`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.status === 'pending' && {
        component: 'dialogFormButton',
        props: {
          label: '拒绝',
          can: 'accounts.update',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'reject_reason',
              renderCell: {
                required: true,
                hint: '微信订阅消息仅能显示前20个字符'
              }
            }
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/reject`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      row.status === 'rejected' && {
        component: 'confirmButton',
        props: {
          label: '重新审核',
          type: 'primary',
          can: 'accounts.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/pend`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'dialogFormButton',
        props: {
          label: '备注',
          can: 'accounts.update_remark',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'remark',
              renderCell: {
                required: true
              }
            }
          ], { data: row, type: 'edit' }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/update_remark`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'accounts.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
          await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>
    ];
  }

  async handleSubmit({ data }) {
    try {
      this.formLoading = true;
      let body = data;
      const action = this.type === 'new' ? 'post' : 'put';
      let path = '/accounts'
      if (this.type === 'edit') {
        path = `/accounts/${body.id}`
      }

      const submitResult = await this.$request[action](path, body);
      const message = this.type === 'new' ? this.$t('bean.createSuccess') : this.$t('bean.updateSuccess');
      this.$message.success(message);
      const id = _.get(submitResult, 'id') || _.get(data, 'id');

      if (id) {
        this.$router.push(linkTo({ item: submitResult || data }));
      }
    } finally {
      this.formLoading = false;
    }
  }
}

export const route = [
  {
    path: '/visitor_accounts',
    name: 'visitor_accounts.index',
    component: VisitorAccounts,
    props: {
      type: 'index',
    }
  },
  {
    path: '/visitor_accounts/new',
    name: 'visitor_accounts.new',
    component: VisitorAccounts,
    props: {
      type: 'new',
    },
    meta: {
      can: ['accounts.create']
    }
  },
  {
    path: '/visitor_accounts/:id',
    name: 'visitor_accounts.show',
    component: VisitorAccounts,
    props: {
      type: 'show',
    }
  },
  {
    path: '/visitor_accounts/:id/edit',
    name: 'visitor_accounts.edit',
    component: VisitorAccounts,
    props: {
      type: 'edit'
    }
  }
]
</script>
